export default __webpack_public_path__ + "fonts/336600db8712eaddf5c1304a78595611.eot";